import styled from '@emotion/styled';
import { Container } from '@hover/blueprint';

const StyledWrapper = styled(Container)`
  height: calc(100vh - 274px);

  @media (max-height: 850px) {
    .svg-container {
      max-height: 360px;

      .svg-back {
        max-height: 360px;
      }

      .svg-image-container {
        max-height: 360px;

        svg {
          max-height: 300px;
        }
      }

      .mobile-frame {
        margin-left: 107px;
        max-width: 170px;

        img {
          max-height: 360px;
        }
      }

      .mobile-image-container {
        max-height: 341px;
        margin-left: 107px;
        max-width: 168px;

        img {
          max-height: 360px;
        }
      }
    }
  }
  @media (max-height: 690px) {
    height: calc(100vh - 218px);

    .svg-container {
      max-height: 270px;

      .svg-back {
        max-height: 270px;
      }

      .svg-image-container {
        max-height: 270px;

        svg {
          max-height: 240px;
        }
      }

      .mobile-frame {
        margin-left: 126px;
        max-width: 130px;

        img {
          max-height: 270px;
        }
      }

      .mobile-image-container {
        max-height: 270px;
        padding-top: 10px;
        margin-left: 130px;
        max-width: 120px;

        img {
          max-height: 270px;
        }
      }
    }
  }

  @media (max-height: 570px) {
    height: calc(100vh - 218px);

    .slider-divider {
      margin: 20px 0;
    }

    .svg-container {
      max-height: 220px;

      .svg-back {
        max-height: 220px;
      }

      .svg-image-container {
        max-height: 220px;

        svg {
          max-height: 190px;
        }
      }

      .mobile-frame {
        margin-left: 138px;
        max-width: 105px;
        img {
          max-height: 220px;
        }
      }

      .mobile-image-container {
        max-height: 220px;
        margin-left: 139px;
        max-width: 100px;
        img {
          max-height: 220px;
        }
      }
    }
  }
`;

export default StyledWrapper;
